var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5C6.4125 7.5 6.76575 7.353 7.05975 7.059C7.35375 6.765 7.5005 6.412 7.5 6C7.5 5.5875 7.353 5.23425 7.059 4.94025C6.765 4.64625 6.412 4.4995 6 4.5C5.5875 4.5 5.23425 4.647 4.94025 4.941C4.64625 5.235 4.4995 5.588 4.5 6C4.5 6.4125 4.647 6.76575 4.941 7.05975C5.235 7.35375 5.588 7.5005 6 7.5ZM6 15C3.9875 13.2875 2.4845 11.697 1.491 10.2285C0.4975 8.76 0.0005 7.4005 0 6.15C0 4.275 0.60325 2.78125 1.80975 1.66875C3.01625 0.55625 4.413 0 6 0C7.5875 0 8.9845 0.55625 10.191 1.66875C11.3975 2.78125 12.0005 4.275 12 6.15C12 7.4 11.503 8.7595 10.509 10.2285C9.515 11.6975 8.012 13.288 6 15Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLocationIcon);
export default __webpack_public_path__ + "static/media/smLocationIcon.729a3c706868f86fb863a7080f7d7294.svg";
export { ForwardRef as ReactComponent };